import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
//primereact
import { Button } from "primereact/button";
import { BreadCrumb } from "primereact/breadcrumb";
import { SplitButton } from "primereact/splitbutton";
//components
import Modal from "../../../components/modal/Modal";
import { useAppContext } from "../../../context/AppContext";

import { AccountForm } from "./AccountForm";
import { AccountReceiptReversal } from "./AccountReceiptReversal";
import { AccountReversedInstallments } from "./AccountReversedInstallments";
import { useFinancialContext } from "../../../context/FinancialContext";
import { AccountReversedShipping } from "./AccountReversedShipping";
import { generateShipping } from "../../../services/Parcel/generateShipping";
import { generateBillet } from "../../../services/Parcel/generateBillet";

export const AccountHeader = ({ updatedTable, form }) => {
  const navigate = useNavigate();
  const { permissions } = useAppContext();
  const { selectedCustomers, setSelectedCustomers, isVisibleButtons, setIsVisibleButtons } = useFinancialContext();

  const [receivables, setReceivables] = useState();
  const [modalReceipt, setModalReceipt] = useState(false);
  const [reversedInstallments, setReversedInstallments] = useState(false);
  const [reversedShipping, setReversedShipping] = useState(false);

  const spreadsheet = [
    ...(permissions && permissions.includes("115")
      ? [
          //Estornar Recebimento
          {
            label: "Recebimento",
            icon: "fa fa-file-invoice-dollar",
            command: () => {
              const existReceived = selectedCustomers.filter(
                (item) => item.status === 1
              );
              const existRenegotiate = selectedCustomers.filter(
                (item) => item.status === 3
              );
              const existIbJuridico = selectedCustomers.filter(
                (item) => item.status === 2
              );

              if (
                existReceived.length > 0 &&
                existReceived.length === selectedCustomers.length
              ) {
                setModalReceipt(true);
              } else if (existRenegotiate.length > 0) {
                toast.warning(
                  "Selecione apenas parcelas sem renegociacão em andamento"
                );
              } else if (existIbJuridico.length > 0) {
                toast.warning(
                  "Selecione apenas parcelas que não estejam no Ib Juridico"
                );
              } else {
                toast.warning("Selecione apenas parcelas pagas");
              }
            },
          },
        ]
      : []),
    ...(permissions && permissions.includes("164")
      ? [
          //Fazer Estorno de Remessas
          {
            label: "Remessa",
            icon: "fa fa-solid fa-file-lines",
            command: () => {
              const existShipping = selectedCustomers.filter(
                (item) => item.shipping != 0
              );

              if (
                existShipping.length > 0 &&
                existShipping.length === selectedCustomers.length
              ) {
                setReversedShipping(true);
              } else {
                toast.warning("Selecione apenas parcelas com remessa");
              }
            },
          },
        ]
      : []),
    ...(permissions && permissions.includes("124")
      ? [
          //Fazer Estorno de Parcelas
          {
            label: "Parcela",
            icon: "fa fa-solid fa-copy",
            command: () => {
              const existRenegotiate = selectedCustomers.filter(
                (item) => item.status === 3
              );
              const existIbJuridico = selectedCustomers.filter(
                (item) => item.status === 2
              );
              const existShipping = selectedCustomers.filter(
                (item) => item.shipping != 0
              );

              if (existRenegotiate.length > 0) {
                toast.warning(
                  "Selecione apenas parcelas sem renegociacão em andamento"
                );
              } else if (existIbJuridico.length > 0) {
                toast.warning(
                  "Selecione apenas parcelas que não estejam no Ib Juridico"
                );
              } else if (existShipping.length > 0) {
                toast.warning(
                  "Selecione apenas parcelas que não estejam com remessa em andamento/gerada"
                );
              } else {
                setReversedInstallments(true);
              }
            },
          },
        ]
      : []),
  ];

  const handleGenerateShipping = async () => {
    const notification = toast.loading("Gerando remessa...");
    let obj = {
      action: "shipping",
    };

    const arrByID = selectedCustomers?.map((item) => {
      return item.id;
    });
    obj.installments_id = arrByID;
    obj.enterprise_id = form.getValues("enterprise_id");

    try {
      const response = await generateShipping(obj);

      if (response.success) {
        toast.update(notification, {
          render: "Parcelas enviadas para a fila de remessa!",
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
      } else {
        const errorMessage =
          response.error && response.error
            ? response.error
            : "Não foi possível fazer a ação.";

        toast.update(notification, {
          render: errorMessage,
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
      }
    } catch (error) {
      const errorMessage = error.message || "Ocorreu um erro inesperado.";

      toast.update(notification, {
        render: errorMessage,
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
    } finally {
      // setSelectedValue(null); // Se precisar resetar valores
    }
  };

  // Função para alternar o modo de exibição dos checkboxes
  const toggleCheckboxes = () => {
    setIsVisibleButtons(!isVisibleButtons);
    setSelectedCustomers([]);
  };

  // Função para imprimir boletos
  const sendPrintBillet = () => {
    if (selectedCustomers.length === 0) {
      return toast.warning("Selecione ao menos um boleto para impressão.");
    }

    let obj = {
      enterprise_id: form.getValues("enterprise_id"),
      installments_id: [],
    };

    const selectedParcelIds = selectedCustomers.map(
      (selectedParcel) => selectedParcel.id
    );

    const loadingNotification = toast.loading(
      "Por favor, aguarde a ação está sendo realizada..."
    );

    selectedParcelIds.forEach((id) => {
      obj.installments_id.push(id);
    });

    generateBillet(obj)
      .then((result) => {
        if (!result.error) {
          toast.update(loadingNotification, {
            render: "Imprimindo Boletos...",
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            type: "success",
            isLoading: false,
          });

          if (result.link) {
            function downloadPDF(url) {
              window.open(url, '_blank');
            }
            downloadPDF(result.link);
          }

          toast.update(loadingNotification, {
            render: "Boletos Impressos",
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            type: "success",
            isLoading: false,
          });
        } else {
          toast.update(loadingNotification, {
            render: result.error,
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            type: "error",
            isLoading: false,
          });
        }
      })
      .catch((error) => {
        toast.update(loadingNotification, {
          render: "Não foi possível imprimir boletos!",
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
        console.error("Erro ao gerar boletos:", error);
      });
    
    setSelectedCustomers([]);
  };

  const optionsActions = [
    ...(permissions && permissions.includes("45")
      ? [
          //Gerar Remessa
          {
            label: "Gerar Remessa",
            icon: "fa fa-file-arrow-up",
            command: () => handleGenerateShipping(),
            // command: () => handleOptionSelect("shipping"),
          },
        ]
      : []),
    ...(permissions && permissions.includes("114")
      ? [
          //Baixar Parcelas
          {
            label: "Baixar Parcela",
            icon: "fa fa-download",
            command: () => handleDownloadParcel(),
          },
        ]
      : []),
  ];

  const items = [
    {
      template: () => (
        <Link to={"/financial/accountReceivable"} className="p-breadcrumb-link">
          Contas a Receber
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  function closeModal() {
    setModalReceipt(false);
    setReversedInstallments(false);
    setSelectedCustomers([]);
    updatedTable();
  }

  function closeAddReceivables() {
    setReceivables(false);
  }

  function handleDownloadParcel() {
    const validade = selectedCustomers?.map((item) => {
      return item.status === 1;
    });

    const existRenegotiate = selectedCustomers.filter(
      (item) => item.status === 3
    );
    const existIbJuridico = selectedCustomers.filter(
      (item) => item.status === 2
    );
    if (existRenegotiate.length > 0) {
      return toast.warning(
        "Selecione apenas parcelas sem renegociacão em andamento"
      );
    }
    if (existIbJuridico.length > 0) {
      return toast.warning(
        "Selecione apenas parcelas que não estejam no Ib Juridico"
      );
    }

    if (selectedCustomers && !validade.includes(true)) {
      navigate("/financial/downloadParcel");
    }
    if (validade.includes(true)) {
      toast.warning("Não é possível a baixa de parcelas pagas!");
    }
  }

  return (
    <div className="row p-0">
      <div className="col-xl-4">
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      <div className="col-xl-8 text-end p-0">
        <div className="row justify-content-end pb-3">
          {permissions &&
            ["115", "164", "124"].some((perm) =>
              permissions.includes(perm)
            ) && (
              <div className="col-xl-3 col-md-6">
                <SplitButton
                  label="Estornar"
                  disabled={selectedCustomers?.length === 0}
                  icon="fa fa-undo"
                  model={spreadsheet.filter(
                    (item) => item !== false && typeof item === "object"
                  )}
                  rounded
                  severity="danger"
                  className="w-100 pb-2"
                />
              </div>
            )}

          {permissions && ["45", "114"].some((perm) => permissions.includes(perm)) && (
            <div className="col-xl-3 col-md-6">
              <SplitButton
                label="Ações"
                disabled={selectedCustomers?.length === 0}
                icon="fa-solid fa-sliders"
                model={optionsActions}
                rounded
                severity="secondary"
                className="w-100 pb-2"
              />
            </div>
          )}

          {permissions && permissions.includes("38") && ( // Imprimir Boleto
            <div className="col-xl-3 col-md-6 mb-2">
              <Button
                rounded
                severity="info"
                label={isVisibleButtons ? "Boleto" : "Voltar"}
                icon="fa fa-money-check-dollar"
                onClick={toggleCheckboxes}
                className="p-inputtext-sm me-2 m-auto w-100"
              />
            </div>
          )}

          {!isVisibleButtons && permissions && permissions.includes("38") && ( // Imprimir Boleto
            <div className="col-xl-3 col-md-6 mb-2">
              <Button
                rounded
                severity="warning"
                label="Imprimir Boletos"
                icon="fa fa-money-check-dollar"
                onClick={sendPrintBillet}
                className="p-inputtext-sm me-2 m-auto w-100"
              />
            </div>
          )}

          {isVisibleButtons && permissions &&
            permissions.includes("113") && ( // Lançar Parcela
              <div className="col-xl-3 col-md-6 mb-2">
                <Button
                  rounded
                  severity="success"
                  label="Lançamento"
                  icon="fa fa-plus"
                  onClick={() => setReceivables(true)}
                  className="p-inputtext-sm me-2 m-auto w-100"
                />
              </div>
            )}
        </div>
      </div>

      <Modal
        visible={receivables}
        dynamicTitle={"Contas a receber"}
        onHide={closeAddReceivables}
        closable={true}
      >
        <AccountForm closeModal={closeAddReceivables} />
      </Modal>

      <Modal
        visible={modalReceipt}
        dynamicTitle={"Confirmar estorno de recebimento"}
        onHide={() => setModalReceipt(false)}
        closable={true}
      >
        <AccountReceiptReversal
          closeModal={closeModal}
          rowsSelected={selectedCustomers}
        />
      </Modal>

      <Modal
        visible={reversedInstallments}
        dynamicTitle={"Confirmar parcelas estornadas"}
        onHide={() => setReversedInstallments(false)}
        closable={true}
      >
        <AccountReversedInstallments
          closeModal={closeModal}
          rowsSelected={selectedCustomers}
        />
      </Modal>

      <Modal
        visible={reversedShipping}
        dynamicTitle={"Confirmar estorno de remessas"}
        onHide={() => setReversedShipping(false)}
        closable={true}
      >
        <AccountReversedShipping
          closeModal={closeModal}
          setVisible={setReversedShipping}
          rowsSelected={selectedCustomers}
          setRowsSelected={setSelectedCustomers}
        />
      </Modal>
    </div>
  );
};
